export enum WoundOrderStatusEnum {
  Drafted = 1,
  RequiresClinicalVerification = 2,
  InProgress = 3,
  DiscontinueDrafted = 4,
  Discontinued = 5
}

export const WoundOrderStatusOptions = [
{ id: 1, label: 'Drafted' },
{ id: 2, label: 'Requires Clinical Verification' },
{ id: 3, label: 'In Progress' },
{ id: 4, label: 'Discontinue Drafted' },
{ id: 5, label: 'Discontinued' }
];
